import React from 'react';


export default function CampaignRecipients({ campaign }) {
  const { recipients } = campaign;
  if (recipients.length > 0) {
    return (
      <div className="block recipients">
        <div className="underline-header">
          <h4>Recipients ({recipients.length})</h4>
        </div>
        <div className="block-content">
          {recipients.map(recipient => recipient.name).join(', ')}
        </div>
      </div>
    );
  } else
    return null;
}
